<template>
    <v-col cols="12" class="pa-1">
        <v-card class="soli-round">
            <v-container fluid>
                <v-simple-table>
                    <template>
                        <tbody
                            v-for="(group, groupName) in groupedReports"
                            :key="groupName"
                        >
                            <tr>
                                <td
                                    class="font-weight-bold soli-grey"
                                    colspan="2"
                                >
                                    {{ groupName }}
                                </td>
                            </tr>
                            <tr
                                v-for="report in group"
                                :key="report.link"
                                @click="$inertia.visit(report.link)"
                                class="cursor-pointer"
                            >
                                <td>
                                    <Link
                                        :href="report.link"
                                        class="font-semibold"
                                    >
                                        {{ report.title }}
                                    </Link>
                                </td>
                                <td>{{ report.subtitle }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-container>
        </v-card>
        <!--<v-data-table
            :headers="headers"
            :items="reports"
            hide-default-footer
            disable-pagination
            groupBy="group"
        />-->
        <!--<div
            v-for="(group, groupName) in groupedReports"
            :key="groupName"
            class=""
        >
            <div class="flex w-full text-h5 font-weight-bold soli-grey mb-3">
                {{ groupName }}
            </div>
            <v-row v-masonry>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    v-for="report in groupedReports[groupName]"
                    :key="report.link"
                >
                    <v-card class="soli-round">
                        <Link :href="report.link">
                            <v-container>
                                <v-list class="soli-grey">
                                    <v-card-title>{{
                                        report.title
                                    }}</v-card-title>
                                    <v-card-subtitle>{{
                                        report.subtitle
                                    }}</v-card-subtitle></v-list
                                >
                            </v-container>
                        </Link>
                    </v-card>
                </v-col>
            </v-row>
        </div>-->
    </v-col>
</template>

<script>
import { Link } from "@inertiajs/vue2";

export default {
    props: [],
    components: {
        Link,
    },
    computed: {
        groupedReports() {
            const grouped = {};
            this.reports.forEach((report) => {
                if (!grouped[report.group]) {
                    grouped[report.group] = [];
                }
                grouped[report.group].push(report);
            });
            return grouped;
        },
        headers() {
            return [
                {
                    text: "Report",
                    value: "title",
                },
                {
                    text: "Description",
                    value: "subtitle",
                },
            ];
        },
        reports() {
            return [
                {
                    show: false, //this.can("View admin reports"),
                    link: "/dashboard/reports/weekly-recap",
                    title: "Weekly Studio Recap",
                    subtitle: "Trailing week KPIs by location",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/studio-health",
                    title: "Studio Health",
                    subtitle: "Monthly Studio KPIs",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/leads",
                    title: "Leads",
                    subtitle: "Lead tracking",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/first-visits",
                    title: "First Visits",
                    subtitle: `View student's first time visiting a
                                        class or private lesson series`,
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/enrollments",
                    title: "Enrollments",
                    subtitle: "View memberships sold",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/withdrawals",
                    title: "Withdrawals",
                    subtitle: "View Membership cancellations",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/program-performance",
                    title: "Program Performance",
                    subtitle: "View program performance by location",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/instrument-performance",
                    title: "Instrument Performance",
                    subtitle: "View instrument performance by location",
                    group: "KPIs",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/exit-forms/",
                    title: "Exit Forms",
                    subtitle: "Withdrawal requests by month",
                    group: "Client Feedback",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/student-surveys/",
                    title: "Student Surveys",
                    subtitle: "How our students think we're doing",
                    group: "Client Feedback",
                },
                {
                    show: this.can("View financial reports"),
                    link: "/dashboard/reports/payroll",
                    title: "Payroll",
                    subtitle: "Attendance by pay period",
                    group: "Finances",
                },
                {
                    show: this.can("View generic reports"),
                    link: "/dashboard/reports/past-due-invoices",
                    title: "Past Due Invoices",
                    subtitle: "Review unpaid charges",
                    group: "Finances",
                },
                {
                    show: this.is("Teacher"),
                    link: "/dashboard/reports/my-attendance",
                    title: "My Attendance Report",
                    subtitle: "Attendance by pay period",
                    group: "Finances",
                },
                {
                    show: this.can("View financial reports"),
                    link: "/dashboard/reports/upcoming-invoices",
                    title: "Upcoming Invoices",
                    subtitle: "Preview customer charges",
                    group: "Finances",
                },
                {
                    show: this.can("View financial reports"),
                    link: "/dashboard/reports/transactions/",
                    title: "Transactions",
                    subtitle: "Transactions by month",
                    group: "Finances",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/membership-prices",
                    title: "Membership Prices",
                    subtitle:
                        "Review and update all prices on active memberships",
                    group: "Sales",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/drop-ins",
                    title: "Drop-Ins",
                    subtitle: "View Drop-in passes sold",
                    group: "Sales",
                },
                {
                    show: this.can("View admin reports"),
                    link: "/dashboard/reports/gift-cards",
                    title: "Gift Cards",
                    subtitle: "Review gift card purchases",
                    group: "Sales",
                },
                {
                    show: false, //this.can("View financial reports"),
                    link: "/dashboard/reports/location-instrument-capacity",
                    title: "Instrument Availability",
                    subtitle: "Columbus studio capacity by instrument",
                },
                /*{
                    show: this.can("View owner reports"),
                    link: "/dashboard/reports/finance-entry",
                    title: "Finance Entry",
                    subtitle: "Record Quickbooks monthly finances",
                },*/
                {
                    show: this.can("View admin reports"),
                    link: "/dashboard/reports/cross-studio-payroll",
                    title: "Cross Studio Payroll",
                    subtitle: "Monthly total reschedules owed between studios",
                    group: "Finances",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/time-clock",
                    title: "Time Clock",
                    subtitle: "Review time clock entries by pay period",
                    group: "Finances",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/founders-memberships",
                    title: "Founders Memberships",
                    subtitle: "Review Founders Membership sales",
                    group: "Sales",
                },
                {
                    show: this.can("View statistical reports"),
                    link: "/dashboard/reports/event-history",
                    title: "Event History",
                    subtitle: "View event history by location",
                    group: "Sales",
                },
            ].filter((e) => e.show);
        },
    },
};
</script>
